import React from 'react';

import { defaultStrings } from 'js/config/config';

export class WelcomeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showWelcomeModal: true };
  }

  closeWelcomeModal() {
    this.setState({ showWelcomeModal: false });
  }

  render() {
    const showWelcome = this.state.showWelcomeModal ? '' : 'hidden';

    // Determine component for welcome based on license type
    // let component = null;
    // if (this.props.userInfo.loggedIn) {
    //   if (this.props.userInfo.licenseType === 'SINGLE') {
    //     component = (
    //       <IndividualLicense
    //         userInfo={this.props.userInfo}
    //         closeWelcomeModal={this.closeWelcomeModal.bind(this)}
    //       />
    //     );
    //   } else if (
    //     this.props.userInfo.licenseType.toLowerCase() === 'license holder' ||
    //     this.props.userInfo.licenseType.toLowerCase() === 'license access'
    //   ) {
    //     component = (
    //       <CorporateLicense
    //         userInfo={this.props.userInfo}
    //         closeWelcomeModal={this.closeWelcomeModal.bind(this)}
    //       />
    //     );
    //   }
    // } else {
    //   component = (
    //     <Guest closeWelcomeModal={this.closeWelcomeModal.bind(this)} />
    //   );
    // }

    return (
      <div className={`details-popup-wrapper ${showWelcome}`}>
        <div id={'welcomePopup'} className={'details-popup'}>
          <div className='popup-header blue darken-3 welcome-header'>
            <span>{defaultStrings.applicationTitle}</span>
            <span className='details-popup-close-icon' onClick={this.closeWelcomeModal.bind(this)}></span>
          </div>
          {/* {component} */}
          <BetaSplash />
        </div>
      </div>
    );
  }
}
//<div className='text-justify font-size-body welcome-warning'>Due to system upgrades, online purchases will not be available from <b>Thursday, February 7 at 5 p.m. EST through Monday, February 11</b>. Existing customers will be able to access the site. Thank you for your patience. If you need assistance during this time period, please contact <a href='mailto:pubs-technology@asce.org'>pubs-technology@asce.org</a>.</div>
class Guest extends React.Component {
  render() {
    return (
      <div className='popup-body padding welcome-body'>
        <div className='text-justify font-size-body'>{defaultStrings.welcomeModalBodyText}</div>
        <div className='login-action-container'>
          <a href={defaultStrings.signInUrl + document.URL} className='waves-effect waves-light btn blue darken-3'>
            Login
          </a>
          <a className='waves-effect waves-light btn blue darken-3' onClick={this.props.closeWelcomeModal}>
            Guest
          </a>
        </div>
        <hr />
        <div>
          <div className='red-text text-darken-2 text-center'>New Updates</div>
          {/* <ul className='collection'>
            <li className='collection-item'>Wind speed data now include serviceability wind speeds and identification of hurricane-prone and wind-borne debris regions</li>
            <li className='collection-item'>Seismic data expanded to include 14 coefficients, the seismic design category, and both horizontal and vertical response spectra</li>
            <li className='collection-item'>Seismic spectra provided as graphs, tables, and comma-separated values</li>
          </ul> */}
          <ul>
            <li>
              <span className='red-text'>NOTE: </span>
              <span>
                Due to a disruption at one of their data servers, the Hydrometeorological Design Studies Center, from
                which the ASCE Hazard Tool derives precipitation frequency estimates, is unable to provide data until
                further notice. ASCE is currently working to acquire rain data from an alternate source. We apologize
                for the inconvenience.
              </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

class IndividualLicense extends React.Component {
  render() {
    const { userInfo, closeWelcomeModal } = this.props;
    const { timeLeftInDays, activeLicense, nextStartDate, titleName, endDate, daysBeforeNewStartDate } = userInfo;

    let licenseAboutToExpire = timeLeftInDays < 30;
    let licenseExpired = activeLicense !== 'A';
    let hasUpcomingLicense = !!nextStartDate;

    const welcomeUserText = `Welcome ${titleName}`;
    const newLicenseText = `Your new license will begin on ${nextStartDate}`;
    const expirationWarningText = `Your current license expires on ${endDate.format('dddd, MMMM Do YYYY')}. ${
      hasUpcomingLicense && daysBeforeNewStartDate > 1 ? newLicenseText : ''
    }`;
    const expirationTitleText = 'You do not have an active license.';
    const expirationBodyText =
      'Premium Access provides hazard data for all seven environmental hazards and includes full reporting capabilities.';
    const basicAccessText = 'Basic Access provides free look up of hazard data for only wind and tsunami.';

    return (
      <div className='popup-body padding welcome-body'>
        <div className='welcome-title'> {welcomeUserText} </div>
        {/* Success */}
        <div className='flex flex-column flex-justify-center align-items-center margin-vertical'>
          <a
            className={`button-margin waves-effect waves-light btn blue darken-3 ${licenseExpired ? 'hidden' : ''}`}
            onClick={closeWelcomeModal}
          >
            Continue
          </a>
        </div>
        {/* Expiring */}
        <div className={`license-expiring margin-vertical ${licenseAboutToExpire ? '' : 'hidden'}`}>
          <div className='warning-licenseinfo red-text text-darken-1 text-center'> {expirationWarningText} </div>
        </div>
        {/* Expired */}
        <div className={`license-expiring margin-vertical flex flex-column ${licenseExpired ? '' : 'hidden'}`}>
          <div className='warning-licenseinfo red-text text-darken-1 text-center'> {expirationTitleText} </div>
          {expirationBodyText}
          <div className='text-justify'>{basicAccessText}</div>
          <div className='flex flex-justify-center margin-vertical'>
            <a
              className='flex flex-column flex-justify-center align-items-center margin-vertical waves-effect waves-light btn blue darken-3'
              onClick={closeWelcomeModal}
            >
              Continue
            </a>
          </div>
        </div>
      </div>
    );
  }
}

class CorporateLicense extends React.Component {
  render() {
    const { userInfo, closeWelcomeModal } = this.props;
    const {
      timeLeftInDays,
      licenseType,
      graceDate,
      nextStartDate,
      titleName,
      endDate,
      daysBeforeNewStartDate,
      labelName,
      today,
    } = userInfo;

    // variables
    let corporateAdmin = false;
    let licenseAboutToExpire = false;
    let licenseExpired = false;
    let hasUpcomingLicense = !!nextStartDate;

    const welcomeUserText = `Welcome ${titleName}`;
    const newLicenseText = `Your new license will begin on ${nextStartDate}`;
    const expirationWarningText = `Your corporate license expires on ${endDate.format('dddd, MMMM Do YYYY')}. ${
      hasUpcomingLicense && daysBeforeNewStartDate > 1 ? newLicenseText : ''
    }`;

    const renewText = (
      <div className='text-justify'>
        To renew your corporate license, contact <a href={defaultStrings.asceMail}>amplifytools@asce.org</a> or call
        Customer Service at 1.800.548.2723 or 1.703.295.6300
      </div>
    );
    const expirationTitleText = 'Your corporate license is expired.';

    const expirationBodyText = (
      <div className='text-justify'>
        ASCE has extended access for a limited grace period. To avoid interruption of access, please renew your
        corporate license. Contact <a href={defaultStrings.asceMail}>amplifytools@asce.org</a> or call Customer Service
        at 1.800.548.2723 or 1.703.295.6300
      </div>
    );

    const accessLabelText = labelName.length === 0 ? '' : labelName;

    if (licenseType === 'LICENSE HOLDER') {
      corporateAdmin = true;
    }

    // Determine expired license
    if (today.isAfter(endDate) && today.isBefore(graceDate)) {
      licenseExpired = true;
    } else if (timeLeftInDays < 0) {
      licenseExpired = true;
    } else if (timeLeftInDays >= 0 && timeLeftInDays < 90) {
      licenseAboutToExpire = true;
    }

    return (
      <div className='popup-body padding welcome-body'>
        <div className='welcome-title'> {welcomeUserText} </div>
        <div className='welcome-subtitle'>{accessLabelText}</div>
        {/* Success */}
        <div className='flex flex-column flex-justify-center align-items-center margin-vertical'>
          <a
            className={`button-margin waves-effect waves-light btn blue darken-3 ${licenseExpired ? 'hidden' : ''}`}
            onClick={closeWelcomeModal}
          >
            Continue
          </a>
        </div>
        {/* Expiring */}
        <div className={`license-expiring margin-vertical ${licenseAboutToExpire && corporateAdmin ? '' : 'hidden'}`}>
          <div className='warning-licenseinfo red-text text-darken-1 text-center'> {expirationWarningText} </div>
          {renewText}
        </div>
        {/* Expired */}
        <div
          className={`license-expiring margin-vertical flex flex-column ${
            licenseExpired && corporateAdmin ? '' : 'hidden'
          }`}
        >
          <div className='warning-licenseinfo red-text text-darken-1 text-center'> {expirationTitleText} </div>
          {expirationBodyText}
          <a className={`button-margin waves-effect waves-light btn blue darken-3`} onClick={closeWelcomeModal}>
            Continue
          </a>
        </div>
      </div>
    );
  }
}

class BetaSplash extends React.Component {
  render() {
    return (
      <div className='popup-body padding welcome-body'>
        <div className='text-justify font-size-body'>
          Welcome to the ASCE Hazard Tool, the quick, reliable, and free way to look up key design parameters specified
          in ASCE standards. Now updated with data from{' '}
          <a href='https://ascelibrary.org/doi/book/10.1061/9780784416112' target='_blank'>
            ASCE/SEI 41-23
          </a>{' '}
          and{' '}
          <a href='https://ascelibrary.org/doi/book/10.1061/9780784414859' target='_blank'>
            41-17
          </a>
          !
        </div>
      </div>
    );
  }
}
